import {useState, FC} from "react";
import {Counter} from "./components/Counter";


const App: FC = () => {


    return (
        <Counter/>
    );
};

export default App;
